export default __webpack_public_path__ + "static/Graphik-RegularItalic-Web-a10064bbe0de6c1395f9a525814b8763.svg";